/* Calendar
========================================================*/
import { MEDIA_QUERIES } from '../utils/breakpoints.js';

export function initCalendarFunctions() {
  
  const eventData = [
    { date: '2026-05-02', name: '入試対策講座', url: '/events/123/', type: 'exam' },
    { date: '2026-05-02', name: '入試対策講座', url: '/events/123/', type: 'exam' },
    { date: '2026-05-03', name: 'OPEN CAMPUS', url: '/events/123/', type: 'oc' },
    { date: '2026-05-03', name: '入試対策講座', url: '/events/123/', type: 'exam' },
    { date: '2026-05-04', name: '入試対策講座', url: '/events/123/', type: 'exam' },
    { date: '2026-05-10', name: 'OPEN CAMPUS', url: '/events/123/', type: 'oc' },
    { date: '2026-05-10', name: '表参道で式場見学', url: '/events/123/', type: 'tour' },
    { date: '2026-05-17', name: 'OPEN CAMPUS', url: '/events/123/', type: 'oc' },
    { date: '2026-05-17', name: '表参道で式場見学', url: '/events/123/', type: 'tour' },
    { date: '2026-05-17', name: '入試対策講座', url: '/events/123/', type: 'exam' },
  ];

  if (!document.getElementById('calendarBody')) return;

  let currentDate = new Date();

  function renderCalendar(date) {
    const year = date.getFullYear();
    const month = date.getMonth();
    const today = new Date();
    
    document.getElementById('currentMonthDisplay').innerText = `${year}年 ${month + 1}月`;
    
    const firstDay = new Date(year, month, 1).getDay();
    const lastDate = new Date(year, month + 1, 0).getDate();
    
    let startOffset = (firstDay === 0) ? 6 : firstDay - 1;
    
    let html = '';
    let dayCount = 1;
    
    for (let i = 0; i < 6; i++) {
      html += '<tr>';
      for (let j = 0; j < 7; j++) {
        if (i === 0 && j < startOffset) {
          html += '<td></td>';
        } else if (dayCount > lastDate) {
          html += '<td></td>';
        } else {
          const dateStr = `${year}-${String(month + 1).padStart(2, '0')}-${String(dayCount).padStart(2, '0')}`;
          
          let classes = [];
          
          if (j === 5) classes.push('is-sat');
          if (j === 6) classes.push('is-sun');
          
          if (year === today.getFullYear() && month === today.getMonth() && dayCount === today.getDate()) {
            classes.push('is-today');
          }

          const events = eventData.filter(e => e.date === dateStr);
          let eventHtml = '';
          events.forEach(e => {
            eventHtml += `
              <a href="${e.url}" class="eventLink eventLink--${e.type}">
                <span class="eventIcon"></span>
                <span class="eventText">${e.name}</span>
              </a>`;
          });

          html += `<td class="${classes.join(' ')}"><span class="date-num">${dayCount}</span>${eventHtml}</td>`;
          dayCount++;
        }
      }
      html += '</tr>';
      if (dayCount > lastDate) break;
    }
    document.getElementById('calendarBody').innerHTML = html;
  }

  document.getElementById('prevMonth').addEventListener('click', () => {
    currentDate.setMonth(currentDate.getMonth() - 1);
    renderCalendar(currentDate);
  });
  document.getElementById('nextMonth').addEventListener('click', () => {
    currentDate.setMonth(currentDate.getMonth() + 1);
    renderCalendar(currentDate);
  });

  renderCalendar(currentDate);

  
  
  // accordion
  const mqPc = window.matchMedia(MEDIA_QUERIES.pc);

  (function(){
      let calendarToggle = $(".js-calendarToggle");

      calendarToggle.on("click", function(){
          if (mqPc.matches) return;
          let subMenu = $(this).next();

          $(this).toggleClass("is-active");

          subMenu.slideToggle(400, function() {
              if ($(this).is(':visible')) {
                  $(this).css('display', 'flex');
              }
          });
      });

      window.addEventListener("resize", function(){
          if(mqPc.matches) {
              calendarToggle.addClass("is-active");
              calendarToggle.next().show().css('display', 'flex');
          }
      });
      
      if (mqPc.matches) {
          calendarToggle.addClass("is-active");
          calendarToggle.next().show().css('display', 'flex');
      }
  })();

}